import { render, staticRenderFns } from "./FeeDetailV2.vue?vue&type=template&id=91cdc406&scoped=true"
import script from "./FeeDetailV2.vue?vue&type=script&lang=js"
export * from "./FeeDetailV2.vue?vue&type=script&lang=js"
import style0 from "./FeeDetailV2.vue?vue&type=style&index=0&id=91cdc406&prod&lang=scss&scoped=true"
import style1 from "./FeeDetailV2.vue?vue&type=style&index=1&id=91cdc406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cdc406",
  null
  
)

export default component.exports